import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { Channel } from 'types/channels'
import { ContactCase } from 'types/contacts'
import { SidePanelCopyRow } from './SidePanelCopyRow'
import { SidePanelRow } from './SidePanelRow'

export type ChannelPaymentSidePanelBodyProps = {
  channel: Channel
  contactCase: ContactCase
}

export const ChannelPaymentSidePanelBody = ({
  channel,
  contactCase,
}: ChannelPaymentSidePanelBodyProps) => {
  const { t } = useTranslation()

  return (
    <Box flexCol gapY={12}>
      <SidePanelRow
        label={t('transactions.sideBar.paymentInAmountReceived')}
        content={`${contactCase?.amount} ${contactCase?.currencyCode}`}
      />
      <SidePanelRow
        label={t('transactions.sideBar.receivingWallet')}
        content={`${channel?.walletDescription}`}
      />
      <SidePanelCopyRow
        label={t('transactions.sideBar.channelReference')}
        content={`${channel?.reference}`}
      />
      <SidePanelCopyRow label={t('transactions.sideBar.uuid')} content={`${channel?.uuid}`} />
      <SidePanelCopyRow label={t('transactions.sideBar.hash')} content={`${contactCase?.hash}`} />
    </Box>
  )
}
